export * from './auth/auth';
export * from './auth/auth.module';
//# sourceMappingURL=auth.js.map


//////////////////
// WEBPACK FOOTER
// /Users/maikelbald/laboratorio/NossaCidadeMelhor/angular-app/~/angularfire2/auth.js
// module id = ../../../../angularfire2/auth.js
// module chunks = 7